<template>
  <van-action-sheet v-model="show" @input="handleVisibilityChange" class="operator-action-sheet">
    <div class="operator-header">
      <h2>{{ $t(['选择运营商']) }}</h2>
    </div>
    <div class="operator-selector">
      <!-- Viettel -->
      <div class="operator-item" @click="selectOperator('Viettel')">
        <img src="../../assets/viet_logo.png" class="operator-logo" alt="Viettel" />
        <div class="operator-name">Viettel</div>
      </div>

      <!-- Mobifone -->
      <div class="operator-item" @click="selectOperator('Mobifone')">
        <img src="../../assets/log-mobilogo.png" class="operator-logo" alt="Mobifone" />
        <div class="operator-name">Mobifone</div>
      </div>

      <!-- Vietnamobile -->
      <div class="operator-item" @click="selectOperator('Vietnamobile')">
        <img src="../../assets/logo-vnm-01.png" class="operator-logo" alt="Vietnamobile" />
        <div class="operator-name">Vietnamobile</div>
      </div>

      <!-- Vinaphone -->
      <div class="operator-item" @click="selectOperator('Vinaphone')">
        <img src="../../assets/logo-vinaphone.png" class="operator-logo" alt="Vinaphone" />
        <div class="operator-name">Vinaphone</div>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
export default {
  name: 'OperatorSelector',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false,
      operators: {
        Viettel: 'viettel',
        Mobifone: 'mobifone',
        Vietnamobile: 'vietnamobile',
        Vinaphone: 'vinaphone'
      }
    };
  },

  methods: {
    open() {
      console.log("open");
      this.show = true;
    },

    handleVisibilityChange(visible) {
      this.$emit('input', visible);
    },

    selectOperator(operator) {
      console.log("22222selectOperator", this.operators[operator]);
      this.$emit('select', this.operators[operator]);
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.operator-action-sheet {
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.operator-header {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: #3b82f6;
  }
}

.operator-selector {
  max-height: 70vh;
  overflow-y: auto;
  padding: 8px 16px 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.operator-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  background-color: #f9fafb;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: #f0f9ff;
  }

  .operator-logo {
    max-width: 100px;
    height: 60px;
    object-fit: contain;
    margin-bottom: 12px;
  }

  .operator-name {
    font-size: 0.875rem;
    font-weight: 500;
    color: #4b5563;
  }
}
</style>